/**
 * CardHeader
 * This is a wrapper component for Material-UI's `CardHeader`
 */
import React, { Fragment } from 'react';
import { Box, CardActionArea } from '@material-ui/core';
import { Link } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import MuiCardHeader from '@material-ui/core/CardHeader';
import clsx from 'clsx';
import { Typography } from '../Typography';
const useStyles = makeStyles(({ palette, spacing }) => ({
    content: {
        display: 'flex',
        flex: '1 1 auto',
        flexDirection: 'column',
        justifyContent: 'center',
    },
    contentRight: {
        marginLeft: spacing(1),
        textAlign: 'right',
    },
    secondaryIconStyles: {
        display: 'flex',
        alignItems: 'center',
        color: palette.secondary.main,
        marginRight: spacing(0.5),
        marginLeft: spacing(0.5),
    },
}));
const CardHeader = props => {
    const { rightTitle, rightSubheader, subheader, title, link, openInNewTab, action, secondaryIcon, ...rest } = props;
    const classes = useStyles({});
    const makeTitle = (text, hasSubheader) => (React.createElement(Typography, { variant: hasSubheader ? 'subtitle2' : 'subtitle1' }, text));
    const makeSubheader = (subhead) => (React.createElement(Typography, { variant: "caption", color: "textSecondary", fontWeight: "regular" }, subhead));
    const actionWrapper = secondaryIcon ? (React.createElement(Box, { display: "flex", alignItems: "center" },
        React.createElement("span", { className: classes.secondaryIconStyles }, secondaryIcon),
        action)) : (action);
    const content = (React.createElement(Fragment, null,
        React.createElement("div", { className: classes.content },
            title && makeTitle(title, Boolean(subheader)),
            subheader && makeSubheader(subheader)),
        (rightTitle || rightSubheader) && (React.createElement("div", { className: clsx(classes.content, classes.contentRight) },
            rightTitle && makeTitle(rightTitle, Boolean(rightSubheader)),
            rightSubheader && makeSubheader(rightSubheader)))));
    const component = React.createElement(MuiCardHeader, Object.assign({ disableTypography: true, title: content, action: actionWrapper }, rest));
    return link ? (React.createElement(CardActionArea, { target: openInNewTab ? '_blank' : '', component: Link, to: link }, component)) : (component);
};
export default CardHeader;
//# sourceMappingURL=CardHeader.js.map